<div>
	@if (loading()) {
		<div class="flex flex-col gap-5">
			<app-payment-skeleton-item />
			<app-payment-skeleton-item />
			<app-payment-skeleton-item />
		</div>
		
	} @else {
		@if(paymentMethods() && paymentMethods().length > 0){
			<div class="flex flex-col gap-2">
				@for (paymentMethod of paymentMethods(); track paymentMethod.id) {
					<app-payment-card-item
						[paymentMethod]="paymentMethod"
						(click)="setPayment(paymentMethod)" />
				}
			</div>
		}
		
	}
</div>
